<template>
  <PVMessage v-bind="getPreset()">
    <slot />
  </PVMessage>
</template>

<script lang="ts" setup>
  import { MessageProps } from 'primevue/message';

  type Preset = MessageProps;

  const props = defineProps<{
    contentCentred?: boolean;
    inputDescription?: boolean;
    simpleError?: boolean;
  }>();

  function getPreset(): Preset {
    switch (true) {
      case props.contentCentred:
        return contentCentredPreset;
      case props.inputDescription:
        return inputDescriptionPreset;
      case props.simpleError:
        return simpleErrorPreset;
      default:
        return {};
    }
  }

  const inputDescriptionPreset: MessageProps = {
    pt: {
      text: {
        class: 'input-description',
        style: {
          'font-size': '0.75rem',
        },
      },
    },
  };
  const contentCentredPreset: MessageProps = {
    pt: {
      content: {
        style: {
          'justify-content': 'center',
        },
      },
    },
  };
  const simpleErrorPreset: MessageProps = {
    severity: 'error',
    variant: 'simple',
  };
</script>

<style scoped lang="scss">
  :deep(.input-description) {
    color: $placeholder-font-color;
  }
</style>
